import React from 'react';
import Navbar from '../../components/Navbar/Navbar';

const Blog = () => {
    return (
        <div>
            <Navbar></Navbar>
            <h3>Hello from blog</h3>
        </div>
    );
};

export default Blog;